/* eslint-disable */
import VueApexCharts from "vue3-apexcharts";
import axios from "axios";

export default {
  name: "RbqmBaselineDashboard",
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
    autofilldata:[],
    showSuggestions: false,
    loadingHeatmap: false,
    loadingPerformance: false,
    loadingComplexity: false,
    loadingSitePerformance: false,
    loadingQTL: false,
      // Filters
      therapeuticArea: "Alzheimer's",
      studyPhase: "PHASE2",
      timeRange: "5",
      riskThreshold: 10,

      // KPI values
      avgEnrollment: 0,
      avgDuration: 0,
      completedstudycount: 0,
      totalstudycount: 0,
      terminatedstudycount: 0,
      withdrawnstudycount: 0,
      completionRate: 0,
      riskScore: 0,
      riskLevelLabel: "Unknown",

      // Table data
      highRiskTrials: [],
      loadhighriskindiator: false,

    riskHeatmapSeries: [],
    riskHeatmapOptions: {
      chart: {
        type: "heatmap",
        toolbar: { show: false },
      },
      dataLabels: {
        enabled: false,
      },
      plotOptions: {
        heatmap: {
          shadeIntensity: 0.5,
          colorScale: {
           ranges: [
            { from: 0,        to: 50,        name: "Low",    color: "#27ae60" },
            { from: 50.0001,  to: 70,        name: "Medium", color: "#f39c12" },
            { from: 70.0001,  to: 100,       name: "High",   color: "#e74c3c" },
          ],
          },
        },
      },
      xaxis: {
        type: "category",
        title: { text: "Therapeutic Area" },
        categories: [],
      },
      yaxis: {
        title: { text: "Phase" },
      },
      legend: {
        position: "bottom",
      },
    },

    // pagination + raw data
    riskHeatmapMetrics: [],          // full rows from API
    riskHeatmapTherapeuticAreas: [], // ALL x-axis areas
    riskHeatmapPhases: [],           // ALL phases/series names
    heatmapPageSize: 12,
    heatmapCurrentPage: 1,

      // 2) Performance vs Baseline (grouped bar, driven by API)
      performanceSeries: [],
      performanceOptions: {
        chart: {
          type: "bar",
          stacked: false,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "50%",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: [], // will be filled from API (sites)
          title: { text: "Sites" },
          labels: {
            rotate: -45,
            formatter(value) {
              if (!value) return "";
              return value.length > 8 ? value.slice(0, 8) + "..." : value;
            },
          },
        },
        yaxis: {
          title: { text: "Rate (%)" },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: "top",
        },
        tooltip: {
          x: {
            formatter(value) {
              return value; // full site name in tooltip
            },
          },
          y: {
            formatter(val) {
              return `${val}`;
            },
          },
        },
      },

      // 3) Protocol Complexity (donut)
      // 3) Protocol Complexity (donut, driven by API)
        complexitySeries: [],
complexityOptions: {
  chart: {
    type: "donut",
    toolbar: { show: false },
  },
  labels: [],
  legend: {
    position: "bottom",
  },
},



      // 4) Site Performance (grouped bar, driven by API)
      sitePerformanceSeries: [],
      sitePerformanceOptions: {
        chart: {
          type: "bar",
          stacked: false,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "50%",
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: [], // full site names from API
          title: { text: "Clinical Sites" },
          labels: {
            rotate: -45,
            formatter(value) {
              if (!value) return "";
              return value.length > 8 ? value.slice(0, 8) + "..." : value;
            },
          },
        },
        yaxis: {
          title: { text: "Performance Score (%)" },
        },
        legend: {
          position: "top",
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          x: {
            formatter(value) {
              return value; // full site name in tooltip
            },
          },
        },
      },

      // 5) QTL – Quality Tolerance Limits - Historical Distribution (driven by API)
      // We’ll treat it as an area chart with sites on X and metric values on Y.
      qtlSeries: [],
      qtlOptions: {
  chart: {
    type: "area",
    toolbar: { show: false },
  },
  stroke: {
    curve: "smooth",
    width: 2,
  },
  dataLabels: {
    enabled: false,
  },
  xaxis: {
    categories: [],
    title: { text: "Year" },
  },
  yaxis: {
    title: { text: "Number of Breaches" },
  },
  legend: {
    position: "top",
  },
},
    };
  },
  computed: {
    riskLevelClass() {
      if (this.riskLevelLabel === "High") return "risk-high";
      if (this.riskLevelLabel === "Medium") return "risk-medium";
      return "risk-low";
    },
    heatmapTotalPages() {
  const total = this.riskHeatmapTherapeuticAreas.length;
  return total ? Math.ceil(total / this.heatmapPageSize) : 1;
},
  },
  mounted() {
    this.getstudymetrics();
    this.getHighRiskIndicators();
    this.getsiteperformance();
    this.getriskheatmap();
    this.getqualitytolerance();
    this.getComplexityRiskAnalysis()
  },
  methods: {
async autofillFun() {
  this.autofilldata = [];
    if(this.therapeuticArea == ""){
      return
    }
      try {
        const res = await axios.get(
          `${this.baseurl}/aact-connection-py/aact/searchconditions?query=${this.therapeuticArea}`
        );

        console.log("autofillFun result = ", res.data);
        this.autofilldata = res.data.conditions;

      } catch (err) {
        console.log("error in autofillFun", err);

      }
    },
selectSuggestion(value) {
      this.therapeuticArea = value;
      this.showSuggestions = false;
      this.updateDashboard(); // run search after selecting
    },

    handleBlur() {
      // small delay so click on suggestion can fire first
      setTimeout(() => {
        this.showSuggestions = false;
      }, 150);
    },

     async getComplexityRiskAnalysis() {
       this.loadingComplexity = true;
  try {
    const res = await axios.get(
      `${this.baseurl}/aact-connection-py/aact/protocolcomplexity?therapeutic_area=${this.therapeuticArea}&phase=${this.studyPhase}&time_range=${this.timeRange}`
    );

    console.log("getComplexityRiskAnalysis result = ", res.data);

    const payload = res.data || {};
    const items = Array.isArray(payload.protocol_complexity_data)
      ? payload.protocol_complexity_data
      : [];

    if (!items.length) {
      this.complexitySeries = [];
      this.complexityOptions = {
        ...this.complexityOptions,
        labels: [],
      };
      return;
    }

    const labels = items.map((item) => item.name);

    const series = items.map((item) => {
      const d = item.data || {};
      const val = d.Percentage != null ? Number(d.Percentage) : 0;
      return val;
    });

    this.complexitySeries = series;
    this.complexityOptions = {
      ...this.complexityOptions,
      labels,
    };

  } catch (err) {
    console.log("error in getComplexityRiskAnalysis", err);
    this.complexitySeries = [];
      this.complexityOptions = {
        ...this.complexityOptions,
        labels: [],
      };
  }
  finally {
    this.loadingComplexity = false;
  }
},
    // === 1) Heatmap from API ===
  async getriskheatmap() {
  this.loadingHeatmap = true;
  try {
    const res = await axios.get(
      `${this.baseurl}/aact-connection-py/aact/riskheatmap?therapeutic_area=${this.therapeuticArea.trim()}&time_range=${this.timeRange}`
    );

    console.log("getriskheatmap result = ", res.data);
    const metrics = Array.isArray(res.data?.heatmap_data)
      ? res.data.heatmap_data
      : [];

    if (!metrics.length) {
      console.warn("No heatmap_data returned from API");
      this.riskHeatmapMetrics = [];
      this.riskHeatmapTherapeuticAreas = [];
      this.riskHeatmapPhases = [];
      this.riskHeatmapSeries = [];
      this.riskHeatmapOptions = {
        ...this.riskHeatmapOptions,
        xaxis: {
          ...(this.riskHeatmapOptions.xaxis || {}),
          type: "category",
          categories: [],
          title: { text: "Therapeutic Area" },
          labels: {
            rotate: -45,
            trim: true,
          },
        },
      };
      return;
    }

    // All unique therapeutic areas (x-axis universe)
    const therapeuticAreas = [
      ...new Set(
        metrics
          .map((row) => row.therapeutic_area)
          .filter((v) => v != null && v !== "")
      ),
    ];

    // ---- ✅ SORT PHASES IN ORDER: PHASE1, PHASE2, PHASE3, ... ----
    const rawPhases = [
      ...new Set(
        metrics
          .map((row) => row.phase)
          .filter((v) => v != null && v !== "")
      ),
    ];

    // Helper to extract numeric part from strings like "PHASE1", "PHASE 2", etc.
    const getPhaseNumber = (phase) => {
      if (!phase) return Number.MAX_SAFE_INTEGER;
      const match = String(phase).match(/\d+/); // first number in the string
      return match ? parseInt(match[0], 10) : Number.MAX_SAFE_INTEGER;
    };

    const phases = rawPhases.sort(
      (a, b) => getPhaseNumber(a) - getPhaseNumber(b)
    );
    // -------------------------------------------------------------

    // Save full data & reset to page 1
    this.riskHeatmapMetrics = metrics;
    this.riskHeatmapTherapeuticAreas = therapeuticAreas;
    this.riskHeatmapPhases = phases;
    this.heatmapCurrentPage = 1;

    // Build chart for the first page
    this.buildHeatmapPage();
  } catch (err) {
    this.loadingHeatmap = false;
    console.error("error in getriskheatmap", err);
    this.riskHeatmapMetrics = [];
    this.riskHeatmapTherapeuticAreas = [];
    this.riskHeatmapPhases = [];
    this.riskHeatmapSeries = [];
    this.riskHeatmapOptions = {
      ...this.riskHeatmapOptions,
      xaxis: {
        ...(this.riskHeatmapOptions.xaxis || {}),
        type: "category",
        categories: [],
        title: { text: "Therapeutic Area" },
        labels: {
          rotate: -45,
          trim: true,
        },
      },
    };
  } finally {
    this.loadingHeatmap = false;
  }
},
buildHeatmapPage() {
    const {
      heatmapPageSize,
      heatmapCurrentPage,
      riskHeatmapTherapeuticAreas,
      riskHeatmapPhases,
      riskHeatmapMetrics,
    } = this;

    if (!riskHeatmapTherapeuticAreas.length || !riskHeatmapPhases.length) {
      this.riskHeatmapSeries = [];
      return;
    }

    const start = (heatmapCurrentPage - 1) * heatmapPageSize;
    const end = start + heatmapPageSize;

    // x-axis categories for this page
    const pageAreas = riskHeatmapTherapeuticAreas.slice(start, end);

    const series = riskHeatmapPhases.map((phase) => ({
      name: phase,
      data: pageAreas.map((area) => {
        const match = riskHeatmapMetrics.find(
          (row) => row.phase === phase && row.therapeutic_area === area
        );

        const avgRisk =
          match && match.avg_risk_score != null
            ? Number(match.avg_risk_score)
            : 0;

        return {
          x: area,
          y: avgRisk,
        };
      }),
    }));

    this.riskHeatmapSeries = series;

    // Update x-axis to match this page
    this.riskHeatmapOptions = {
      ...this.riskHeatmapOptions,
      xaxis: {
        ...(this.riskHeatmapOptions.xaxis || {}),
        type: "category",
        categories: pageAreas,
        title: { text: "Therapeutic Area" },
        labels: {
          rotate: -45,
          trim: true,
        },
      },
      yaxis: {
        ...(this.riskHeatmapOptions.yaxis || {}),
        title: { text: "Phase" },
      },
      dataLabels: {
        enabled: false,
      },
    };
  },

  nextHeatmapPage() {
    if (this.heatmapCurrentPage < this.heatmapTotalPages) {
      this.heatmapCurrentPage += 1;
      this.buildHeatmapPage();
    }
  },

  prevHeatmapPage() {
    if (this.heatmapCurrentPage > 1) {
      this.heatmapCurrentPage -= 1;
      this.buildHeatmapPage();
    }
  },
    // === 2) Performance vs Baseline from API ===
    async getperformancevsbaseline() {
      this.loadingPerformance = true;
      let yearint =  parseInt(this.timeRange);
      try {
        const res = await axios.get(
          `${this.baseurl}/aact-connection-py/aact/performancevsbaseline?therapeutic_area=${this.therapeuticArea.trim()}&phase=${this.studyPhase}&years_back=${yearint}`
        );

        console.log("getperformancevsbaseline result = ", res.data);

        const metrics = Array.isArray(res.data) ? res.data : [];

        if (!metrics.length) {
          this.performanceSeries = [];
          this.performanceOptions = {
            ...this.performanceOptions,
            xaxis: {
              ...this.performanceOptions.xaxis,
              categories: [],
            },
          };
          return;
        }

        // 1) Take site names from first metric as x-axis categories
        const firstMetricData = metrics[0].data || {};
        const categories = Object.keys(firstMetricData);

        // 2) Build series: one per metric
        const series = metrics.map((metric) => {
          const metricData = metric.data || {};
          return {
            name: metric.name,
            data: categories.map((siteName) => {
              const raw = metricData[siteName];
              return raw != null ? Number(raw) : 0;
            }),
          };
        });

        // 3) Update chart
        this.performanceSeries = series;
        this.performanceOptions = {
          ...this.performanceOptions,
          xaxis: {
            ...this.performanceOptions.xaxis,
            categories,
          },
        };
      } catch (err) {
        console.log("error in getperformancevsbaseline", err);
      }
      finally {
    this.loadingPerformance = false;
  }
    },

    // === 3) Site Performance from API ===
    async getsiteperformance() {
      this.loadingSitePerformance = true;
      try {
        const res = await axios.get(
          `${this.baseurl}/aact-connection-py/aact/siteperformance?therapeutic_area=${this.therapeuticArea.trim()}&phase=${this.studyPhase}&time_range_years=${this.timeRange}`
        );

        console.log("siteperformance graph result = ", res.data);

        const metrics = res.data.performance.performance?res.data.performance.performance : [];

        if (!metrics.length) {
          this.sitePerformanceSeries = [];
          this.sitePerformanceOptions = {
            ...this.sitePerformanceOptions,
            xaxis: {
              ...this.sitePerformanceOptions.xaxis,
              categories: [],
            },
          };
          return;
        }

        // 1) Take site names from the first metric as x-axis categories
        const firstMetricData = metrics[0].data || {};
        const categories = Object.keys(firstMetricData);

        // 2) Build series for each metric
        const series = metrics.map((metric) => {
          const metricData = metric.data || {};
          return {
            name: metric.name,
            data: categories.map((siteName) => {
              const rawVal = metricData[siteName];
              const value = rawVal != null ? Number(rawVal) : 0;
              return value;
            }),
          };
        });

        // 3) Update chart state
        this.sitePerformanceSeries = series;
        this.sitePerformanceOptions = {
          ...this.sitePerformanceOptions,
          xaxis: {
            ...this.sitePerformanceOptions.xaxis,
            categories,
          },
        };
      } catch (err) {
        console.log("error in siteperformance", err);
      }
      finally {
    this.loadingSitePerformance = false;
  }
    },

    // === 4) High-Risk Trials Table ===
    async getHighRiskIndicators() {
      this.highRiskTrials = [];
      this.loadhighriskindiator = true;
      try {
        const res = await axios.get(
          `${this.baseurl}/aact-connection-py/aact/indicators?therapeutic_area=${this.therapeuticArea.trim()}&phase=${this.studyPhase}&time_range=${this.timeRange}`
        );

        console.log("getHighRiskIndicators result = ", res.data);
        this.highRiskTrials = res.data.recent_high_risk_trials;
        this.loadhighriskindiator = false;
      } catch (err) {
        console.log("error in getHighRiskIndicators", err);
        this.loadhighriskindiator = false;
      }
    },

    // === 5) KPI Summary ===
    async getstudymetrics() {
       const defaultval = {
    avg_completion_rate: 0,
    avg_study_duration_months: 0,
    avg_planned_enrollment: 0,
    avg_risk_score: 0,
    total_study: 0,
    completed_study_count: 0,
    terminated_study_count: 0,
    withdrawn_study_count: 0,
    phases_included: ""
};

      try {
        const res = await axios.get(
          `${this.baseurl}/aact-connection-py/aact/studymetrics?therapeutic_area=${this.therapeuticArea.trim()}&phase=${this.studyPhase}&time_range_years=${this.timeRange}`
        );

        console.log("getstudymetrics result = ", res.data);

        const metrics = res.data || defaultval;
        this.avgEnrollment = metrics.avg_planned_enrollment;
        this.completedstudycount = metrics.completed_study_count;
        this.totalstudycount = metrics.total_study;
        this.terminatedstudycount = metrics.terminated_study_count;
        this.withdrawnstudycount = metrics.withdrawn_study_count;
        this.riskScore = metrics.avg_risk_score;
        this.avgDuration = metrics.avg_study_duration_months;
        this.completionRate = metrics.avg_completion_rate;
      } catch (err) {
        console.log("error in getstudymetrics", err);
        const metrics = defaultval;
        this.avgEnrollment = metrics.avg_planned_enrollment;
        this.completedstudycount = metrics.completed_study_count;
        this.totalstudycount = metrics.total_study;
        this.terminatedstudycount = metrics.terminated_study_count;
        this.withdrawnstudycount = metrics.withdrawn_study_count;
        this.riskScore = metrics.avg_risk_score;
        this.avgDuration = metrics.avg_study_duration_months;
        this.completionRate = metrics.avg_completion_rate;
      }
    },

    // === 6) QTL - Quality Tolerance Limits from API ===
    async getqualitytolerance() {
      this.loadingQTL = true;
  try {
    const res = await axios.get(
      `${this.baseurl}/aact-connection-py/aact/qualitytolerance?therapeutic_area=${this.therapeuticArea.trim()}&phase=${this.studyPhase}&time_range_years=${this.timeRange}`
    );

    console.log("getqualitytolerance result = ", res.data);

    const rows = Array.isArray(res.data) ? res.data : [];

    if (!rows.length) {
      this.qtlSeries = [];
      this.qtlOptions = {
        ...this.qtlOptions,
        xaxis: {
          ...(this.qtlOptions && this.qtlOptions.xaxis
            ? this.qtlOptions.xaxis
            : {}),
          categories: [],
        },
      };
      return;
    }

    // Sort by year (defensive: handle missing year)
    rows.sort(function (a, b) {
      const ay = a && a.year != null ? a.year : 0;
      const by = b && b.year != null ? b.year : 0;
      return ay - by;
    });

    // x-axis: years
    const categories = rows.map(function (row) {
      return String(row.year != null ? row.year : "");
    });

    // Series data
    const screenFailureSeries = rows.map(function (row) {
      return row && row.screen_failure_breach != null
        ? Number(row.screen_failure_breach)
        : 0;
    });

    const dropoutSeries = rows.map(function (row) {
      return row && row.dropout_breach != null
        ? Number(row.dropout_breach)
        : 0;
    });

    const adverseEventSeries = rows.map(function (row) {
      return row && row.adverse_event_breach != null
        ? Number(row.adverse_event_breach)
        : 0;
    });

    this.qtlSeries = [
      {
        name: "Screen Failure Breach",
        data: screenFailureSeries,
      },
      {
        name: "Dropout Breach",
        data: dropoutSeries,
      },
      {
        name: "Adverse Event Breach",
        data: adverseEventSeries,
      },
    ];

    this.qtlOptions = {
      ...this.qtlOptions,
      xaxis: {
        ...(this.qtlOptions && this.qtlOptions.xaxis
          ? this.qtlOptions.xaxis
          : {}),
        categories: categories,
        title: { text: "Year" },
      },
      yaxis: {
        ...(this.qtlOptions && this.qtlOptions.yaxis
          ? this.qtlOptions.yaxis
          : {}),
        title: { text: "Number of Breaches" },
      },
      dataLabels: {
        ...(this.qtlOptions && this.qtlOptions.dataLabels
          ? this.qtlOptions.dataLabels
          : {}),
        enabled: false,
      },
      tooltip: {
        ...(this.qtlOptions && this.qtlOptions.tooltip
          ? this.qtlOptions.tooltip
          : {}),
        shared: true,
        intersect: false,
      },
    };
  } catch (err) {
    console.log("error in getqualitytolerance", err);
    this.qtlSeries = [];
      this.qtlOptions = {
        ...this.qtlOptions,
        xaxis: {
          ...(this.qtlOptions && this.qtlOptions.xaxis
            ? this.qtlOptions.xaxis
            : {}),
          categories: [],
        },
      };
  }
  finally {
    this.loadingQTL = false;
  }
},

    riskClass(level) {
      if (level == "High") return "risk-high";
      if (level == "Medium") return "risk-medium";
      return "risk-low";
    },

    updateDashboard() {
      this.getriskheatmap();
      this.getstudymetrics();
      this.getHighRiskIndicators();
      this.getsiteperformance();
      this.getqualitytolerance();
      this.getComplexityRiskAnalysis()
    },
  },
};
